import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { roleConfig } from '../config/roleConfig';

/**
 * CapabilityGuard - Protects routes based on role capabilities defined in roleConfig.js
 * @param {string} capability - The capability key to check (e.g. 'viewGuests', 'manageGuests')
 * @param {ReactNode} children - Component to render if authorized
 */
const CapabilityGuard = ({ capability, children }) => {
  const { user, isAuthenticated, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        direction: 'rtl'
      }}>
        <div>جاري التحقق من الصلاحيات...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const config = roleConfig[user?.role];
  const hasCapability = config?.capabilities?.[capability];

  if (!hasCapability) {
    const destination = config?.defaultRoute || '/login';
    if (destination === location.pathname) {
      return <Navigate to="/login" replace />;
    }
    return <Navigate to={destination} replace />;
  }

  return children;
};

export default CapabilityGuard;
